var map = {
	"./1.jpg": "./src/images/gallery/UI UX Design/1.jpg",
	"./2.jpg": "./src/images/gallery/UI UX Design/2.jpg",
	"./3.jpg": "./src/images/gallery/UI UX Design/3.jpg",
	"./4.jpg": "./src/images/gallery/UI UX Design/4.jpg",
	"./cover.jpg": "./src/images/gallery/UI UX Design/cover.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images/gallery/UI UX Design sync \\.(png%7Cjpe?g%7Csvg)$";